export default __webpack_public_path__ + "static/screeny-150-gpz-unica-scheda-tecnica-2134157c9673c8ebdae7d5aad367a3f9.pdf";